import {
    FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST,
    findTableColumnsConfigForUserSuccess,
    findTableColumnsConfigForUserFailure
} from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { EMPTY, from } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function findTableColumnsConfigForUserEpic(action$, store$, { TableRepository }) {
  return action$.pipe(
    ofType( FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST ),
    mergeMap( (action) => {
      const { tableKey } = action.payload;

      if(!`${tableKey || ''}`.trim()) {
          return EMPTY;
      }

      return from(
        TableRepository.findUserTableConfig( tableKey )
          .then((tableColumns) => findTableColumnsConfigForUserSuccess({ tableColumns, tableKey }))
          .catch(findTableColumnsConfigForUserFailure),
      );
    }),
  );
}
